// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./pdf-viewer.vue?vue&type=style&index=0&id=2952e02e&lang=css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("2dcfe6b8", content, true, {"sourceMap":false,"shadowMode":false});